import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("umb-market-loader")
export class UmbMarketLoader extends LitElement {
  #delay = 200;
  #timeoutId: NodeJS.Timeout | null = null;
  #onFetchStart = () => this.show();
  #onFetchEnd = () => this.hide();

  connectedCallback() {
    super.connectedCallback();
    this.style.display = "none";
    document.addEventListener("fetch:start", this.#onFetchStart);
    document.addEventListener("fetch:end", this.#onFetchEnd);
  }

  disconnectedCallback() {
    document.removeEventListener("fetch:start", this.#onFetchStart);
    document.removeEventListener("fetch:end", this.#onFetchEnd);
    super.disconnectedCallback();
  }

  show() {
    this.#timeoutId = setTimeout(() => {
      this.style.display = "block";
    }, this.#delay);
  }

  hide() {
    this.#timeoutId ? clearTimeout(this.#timeoutId) : null;
    this.style.display = "none";
  }

  render() {
    return html`<uui-loader-circle></uui-loader-circle> `;
  }

  static styles = css`
    :host {
      z-index: 10000;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(2px); /* blur everything behind */
    }

    uui-loader-circle {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: var(--uui-color-default);
      font-size: 3em;
    }
  `;
}
